<template>
  <div class="row">&nbsp;</div>
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <div class="row">
          <welcomecard />
        </div>
      </div>
    </div>
  </div>

  <div class="container-fluid">
    <div class="card">
      <div v-if="is_authorization === null" class="card-body">
        <div class="d-flex justify-content-center">authorization checking...</div>
      </div>
      <div v-if="is_authorization === 'N'" class="card-body">
        <div class="d-flex justify-content-center">You do not have authorization for this page</div>
      </div>

      <div v-if="is_authorization === 'Y'" class="card-body">
        <div v-if="is_loading === 'Y'" class="d-flex justify-content-center py-5">
          <img style="align-items: center; width: 60px" src="../../assets/images/running_loading.svg" />
        </div>

        <div v-if="is_loading === 'N'">
          <div class="card mb-4">
            <div class="card-header">
              <div class="header-top d-flex justify-content-between align-items-center flex-wrap gap-2">
                <h5 class="m-0"><b>สัญญาว่าจ้าง: {{ eventData.title }}</b></h5>
                <div class="d-flex gap-2">
                  <a :href="'/dashboard-organizer/' + eventData.event_key" class="btn btn-outline-secondary">
                    <vue-feather type="arrow-left" size="16"></vue-feather> กลับหน้ารายงาน
                  </a>
                  <button class="btn btn-primary" :disabled="is_exporting === 'Y'" @click="downloadContractPdf">
                    <span v-if="is_exporting === 'Y'">กำลังสร้าง PDF...</span>
                    <span v-else>ดาวน์โหลด PDF</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- ฟอร์มกรอกข้อมูลสัญญา (ไม่รวมอยู่ใน PDF) -->
          <div class="card mb-4 no-print">
            <div class="card-header">
              <h6 class="m-0"><b>ข้อมูลสำหรับกรอกสัญญา</b></h6>
              <small class="text-muted">ข้อมูลกิจกรรมถูกดึงจากระบบให้อัตโนมัติ ส่วนข้อมูลผู้จัดงาน/ผู้ลงนามกรุณากรอกให้ครบก่อนดาวน์โหลด PDF</small>
            </div>
            <div class="card-body">
              <div class="row g-3">
                <div class="col-md-4">
                  <label class="form-label">วันที่ทำสัญญา (ว/ด/ป)</label>
                  <input type="date" class="form-control" v-model="contract.sign_date" />
                </div>
                <div class="col-md-4">
                  <label class="form-label">ชื่อผู้จัดงาน (บริษัท/องค์กร/บุคคลธรรมดา)</label>
                  <input type="text" class="form-control" v-model="contract.organizer_name" placeholder="เช่น บริษัท ตัวอย่าง จำกัด" />
                </div>
                <div class="col-md-4">
                  <label class="form-label">ผู้มีอำนาจลงนามผูกพัน (ผู้จัดกิจกรรม)</label>
                  <input type="text" class="form-control" v-model="contract.organizer_signer_name" />
                </div>
                <div class="col-md-8">
                  <label class="form-label">ที่อยู่สำนักงานผู้จัดงาน</label>
                  <input type="text" class="form-control" v-model="contract.organizer_address" />
                </div>
                <div class="col-md-6">
                  <label class="form-label">ผู้มีอำนาจลงนามผูกพัน (ผู้ให้บริการ)</label>
                  <input type="text" class="form-control" :value="providerSignerName" disabled />
                </div>
                <div class="col-md-6">
                  <label class="form-label">ตำแหน่งผู้ลงนาม (ผู้ให้บริการ)</label>
                  <input type="text" class="form-control" :value="providerSignerPosition" disabled />
                </div>
                <div class="col-md-12">
                  <label class="form-label">เอกสารแนบท้ายสัญญา (ข้อ 12)</label>
                  <textarea class="form-control" rows="2" v-model="contract.appendix_text"></textarea>
                </div>
              </div>
              <div class="mt-3">
                <button class="btn btn-outline-secondary btn-sm" @click="saveDraft">บันทึกร่าง (เก็บไว้ในเครื่องนี้)</button>
              </div>
            </div>
          </div>

          <!-- เอกสารสัญญา (ส่วนที่แปลงเป็น PDF) -->
          <div class="contract-page-wrapper">
            <div id="contract-pdf" class="contract-page">
              <div class="contract-header-topleft">Contract No: RRC-{{ eventData.event_key }}</div>
              <div class="contract-header-topright">
                <div><b>{{ companyName }}</b></div>
                <div>เลขประจำตัวผู้เสียภาษี {{ companyTaxNo }}</div>
                <div>สำนักงานใหญ่ : {{ companyAddress }}</div>
              </div>
              
              <h5 style="padding-top: 15px;" class="contract-title">สัญญาให้บริการระบบรับสมัครนักวิ่งออนไลน์<br />(RUNRACE.IN.TH)</h5>

              <p>
                &nbsp;&nbsp;&nbsp;สัญญาฉบับนี้ทำขึ้น ณ วันที่ {{ signDay }} เดือน {{ signMonthText }} พ.ศ. {{ signYearBe }} ระหว่าง
                {{ contract.organizer_name || '______________' }} โดย {{ contract.organizer_signer_name || '…………………………………………………' }}
                ผู้มีอำนาจลงนามผูกพัน สำนักงานตั้งอยู่เลขที่ {{ contract.organizer_address || '………………………………………………………………………………………………………' }}
                ซึ่งต่อไปในสัญญานี้เรียกว่า “ผู้จัดงาน” ฝ่ายหนึ่ง
              </p>
              <p>
                กับบริษัท {{ companyName }} โดย {{ providerSignerName }}
                ผู้มีอำนาจลงนามผูกพัน สำนักงานตั้งอยู่เลขที่ {{ companyAddress }}
                ซึ่งต่อไปในสัญญานี้เรียกว่า “ผู้ให้บริการ” อีกฝ่ายหนึ่ง (คู่สัญญาทั้งสองฝ่ายรวมเรียกว่า “คู่สัญญา”)
              </p>
              <br />
              <p>คู่สัญญาทั้งสองฝ่ายตกลงทำสัญญากันโดยมีข้อความและเงื่อนไขดังต่อไปนี้</p>

              <p><b>ข้อ 1. วัตถุประสงค์และรายละเอียดงาน</b></p>
              <p>
                ผู้จัดงานตกลงว่าจ้างและผู้ให้บริการตกลงรับจ้างให้บริการระบบรับสมัครและบริหารจัดการข้อมูลผู้เข้าร่วมงานวิ่งออนไลน์ สำหรับกิจกรรม:
              </p>
              <ul>
                <li>ชื่อกิจกรรม: “{{ eventData.title }}”</li>
                <li>วันที่จัดงาน: {{ eventDateThai }}</li>
                <li>สถานที่จัดงาน: {{ eventData.location || '-' }}</li>
              </ul>

              <p><b>ข้อ 2. ขอบเขตการให้บริการ</b></p>
              <p>ผู้ให้บริการมีหน้าที่จัดเตรียมและดูแลระบบรับสมัครออนไลน์ (https://runrace.in.th) ครอบคลุมฟังก์ชันดังนี้:</p>
              <p>2.1 ระบบรับสมัคร: รองรับการกรอกข้อมูลส่วนบุคคล, ขนาดเสื้อ, และประเภทการแข่งขัน</p>
              <p>2.2 ระบบชำระเงิน: รองรับการชำระเงินออนไลน์ (พร้อมเพย์, บัตรเครดิต) ตามอัตราค่าธรรมเนียมในข้อ 5</p>
              <p>2.3 ระบบตรวจสอบสถานะ: สำหรับผู้สมัครตรวจสอบความถูกต้อง</p>
              <p>2.4 ระบบรายงาน (Backend): สำหรับผู้จัดงานตรวจสอบสถิติผู้สมัครและยอดเงินแบบ Real-time</p>
              <p>2.5 การส่งมอบข้อมูล: จัดส่งไฟล์ข้อมูลผู้สมัครทั้งหมด (Excel/CSV) ให้ผู้จัดงานทันทีหลังปิดรับสมัคร</p>

              <p><b>ข้อ 3. หน้าที่และความรับผิดชอบของผู้จัดงาน</b></p>
              <p>3.1 ความถูกต้องของข้อมูล: รับผิดชอบความถูกต้องของรายละเอียดงานวิ่งทั้งหมด (วัน เวลา สถานที่ ราคา เงื่อนไข) ที่ปรากฏบนระบบ</p>
              <p>3.2 การขออนุญาต: รับรองว่ากิจกรรมจัดขึ้นอย่างถูกต้องตามกฎหมายและได้รับใบอนุญาตที่เกี่ยวข้องครบถ้วน</p>
              <p>3.3 การส่งข้อมูล: จัดส่งข้อมูลที่จำเป็น (โลโก้, รายละเอียด, ขนาดเสื้อ, เงื่อนไข) ให้ผู้ให้บริการล่วงหน้าไม่น้อยกว่า 1 วันทำการก่อนเปิดรับสมัคร</p>
              <p>3.4 การบริหารจัดการงาน: รับผิดชอบการจัดงานวิ่ง, การจัดหาของที่ระลึก (เสื้อ, เหรียญ, BIB), และความปลอดภัยในวันงานแต่เพียงผู้เดียว</p>
              <br /><br /><br /><br />
              <p>3.5 การเลื่อน/ยกเลิกงาน: กรณีเลื่อนหรือยกเลิกงาน ผู้จัดงานต้องรับผิดชอบแจ้งผู้สมัครและดำเนินการคืนเงิน (Refund) ทั้งหมดด้วยค่าใช้จ่ายของตนเอง</p>
              <p>3.6 ความรับผิด: รับผิดชอบชดใช้ค่าเสียหายแก่ผู้ให้บริการ หากเกิดข้อเรียกร้องหรือความเสียหายใดๆ อันเนื่องมาจากการจัดงานหรือการกระทำของผู้จัดงาน</p>

              <p><b>ข้อ 4. หน้าที่และความรับผิดชอบของผู้ให้บริการ</b></p>
              <p>4.1 การดูแลระบบ: ดูแล รักษา สำรองข้อมูล และรักษาความปลอดภัยของระบบให้พร้อมใช้งานตามมาตรฐาน Service Level Agreement (SLA) ที่ระดับไม่น้อยกว่าร้อยละ 99.5 ในช่วงเปิดรับสมัคร (เว้นแต่การปิดปรับปรุงที่แจ้งล่วงหน้า)</p>
              <p>4.2 การแจ้งเหตุขัดข้อง: แจ้งผู้จัดงานทันทีหากระบบมีปัญหา และส่งมอบข้อมูลทั้งหมดเมื่อสิ้นสุดโครงการ</p>

              <p><b>ข้อ 5. ค่าบริการและค่าธรรมเนียม</b></p>
              <p>คู่สัญญาตกลงอัตราค่าบริการ (ยังไม่รวมภาษีมูลค่าเพิ่ม ถ้ามี) ดังนี้:</p>
              <p>5.1 ค่าบริการระบบ: เป็นไปตามที่ตกลงกันในภาคผนวก</p>
              <p>5.2 ค่าธรรมเนียมชำระเงิน (พร้อมเพย์): {{ feePpText }}</p>
              <p>5.3 ค่าธรรมเนียมชำระเงิน (บัตรเครดิต): {{ feeCcText }}</p>

              <p><b>ข้อ 6. การรับชำระเงินและการโอนเงิน</b></p>
              <p>6.1 การรับเงิน: ผู้ให้บริการทำหน้าที่รับชำระเงินค่าสมัครแทนผู้จัดงาน</p>
              <p>
                6.2 การโอนเงิน: ผู้ให้บริการจะโอนเงินรายได้ให้ผู้จัดงานตามรอบที่ตกลงกัน (ระบุในภาคผนวก) โดยจะหักค่าบริการและค่าธรรมเนียมตามข้อ 5 พร้อมค่าธรรมเนียมการโอน 20 บาท ต่อครั้ง โดยใช้เวลาประมาณ 3-5 วันทำการ
              </p>

              <p><b>ข้อ 7. การคุ้มครองข้อมูลส่วนบุคคล (PDPA)</b></p>
              <p>7.1 ความเป็นเจ้าของข้อมูล: ข้อมูลส่วนบุคคลของผู้สมัครถือเป็นกรรมสิทธิ์ของผู้จัดงาน</p>
              <p>7.2 สถานะตามกฎหมาย: ผู้จัดงานมีสถานะเป็น "ผู้ควบคุมข้อมูลส่วนบุคคล" และผู้ให้บริการมีสถานะเป็น "ผู้ประมวลผลข้อมูลส่วนบุคคล"</p>
              <p>7.3 ข้อจำกัดการใช้ข้อมูล: ผู้ให้บริการจะใช้ข้อมูลเพื่อวัตถุประสงค์ตามสัญญานี้เท่านั้น ห้ามนำไปเปิดเผย จำหน่าย หรือใช้ประโยชน์ในเชิงพาณิชย์อื่นโดยเด็ดขาด และต้องรักษาความลับของข้อมูลอย่างเคร่งครัดตาม พ.ร.บ. คุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562</p>

              <p><b>ข้อ 8. ทรัพย์สินทางปัญญา</b></p>
              <p>8.1 ทรัพย์สินของผู้จัดงาน: ชื่อกิจกรรม, โลโก้, รูปภาพ, และฐานข้อมูลผู้สมัครเป็นทรัพย์สินของผู้จัดงาน</p>
              <p>8.2 ทรัพย์สินของผู้ให้บริการ: ซอฟต์แวร์, แพลตฟอร์ม, และระบบงานเป็นทรัพย์สินของผู้ให้บริการ</p>

              <p><b>ข้อ 9. ระยะเวลาสัญญาและการเลิกสัญญา</b></p>
              <p>9.1 ผลบังคับใช้: สัญญามีผลตั้งแต่วันที่ลงนาม จนกระทั่งเสร็จสิ้นการส่งมอบข้อมูลและการเคลียร์ยอดเงินหลังจบกิจกรรม</p>
              <p>9.2 การผิดสัญญา: หากฝ่ายใดผิดสัญญา อีกฝ่ายมีสิทธิแจ้งเป็นลายลักษณ์อักษรให้แก้ไขภายใน ...... วัน หากพ้นกำหนดแล้วยังไม่แก้ไข ฝ่ายที่ได้รับผลกระทบมีสิทธิบอกเลิกสัญญาได้ทันที</p>
              <br /><br /><br /><br /><br />
              <p><b>ข้อ 10. เหตุสุดวิสัย</b></p>
              <p>คู่สัญญาไม่ต้องรับผิดหากไม่สามารถปฏิบัติตามสัญญาได้เนื่องจากเหตุสุดวิสัยตามกฎหมาย โดยฝ่ายที่ประสบเหตุต้องแจ้งให้อีกฝ่ายทราบโดยเร็ว</p>

              <p><b>ข้อ 11. กฎหมายที่ใช้บังคับและการระงับข้อพิพาท</b></p>
              <p>11.1 สัญญานี้บังคับและตีความตามกฎหมายไทย</p>
              <p>11.2 หากมีข้อพิพาท คู่สัญญาตกลงจะเจรจาไกล่เกลี่ยกันโดยสันติวิธีก่อน</p>

              <p><b>ข้อ 12. เอกสารแนบท้ายสัญญา</b></p>
              <p>เอกสารแนบท้าย (ถ้ามี) ให้ถือเป็นส่วนหนึ่งของสัญญานี้ ประกอบด้วย:</p>
              <p>{{ contract.appendix_text || '[ระบุรายการ เช่น ภาคผนวก ก รายละเอียดรอบการโอนเงิน]' }}</p>

              <p>
                สัญญาฉบับนี้ทำขึ้นเป็นสองฉบับ มีข้อความถูกต้องตรงกัน คู่สัญญาได้อ่านและเข้าใจข้อความโดยตลอดแล้ว
                จึงได้ลงลายมือชื่อและประทับตรา (ถ้ามี) ไว้เป็นสำคัญต่อหน้าพยาน โดยเก็บไว้ฝ่ายละหนึ่งฉบับ
              </p>

              <div class="signature-grid">
                <div class="signature-box">
                  <div>(ลงชื่อ) .......................................................</div>
                  <div>ผู้จัดงาน</div>
                  <div>({{ contract.organizer_signer_name || '.......................................................' }})</div>
                </div>
                <div class="signature-box">
                  <div class="signature-line">
                    <img :src="receiptSignature" class="signature-image" alt="ลายเซ็นผู้ให้บริการ" />
                  </div>
                  <div>(ลงชื่อ) .......................................................</div>
                  <div>ผู้ให้บริการ</div>
                  <div>({{ providerSignerName }})</div>
                  <div>ตำแหน่ง {{ providerSignerPosition }}</div>
                </div>
              </div>

              <div class="contract-print-date">Print date: {{ printDate }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import welcomecard from "./user_welcomecard.vue";
import axios from "axios";
import html2canvas from "html2canvas";
import { jsPDF } from "jspdf";
import receiptSignature from "../../assets/images/receipt-signature.png";

const THAI_MONTHS = [
  "มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน",
  "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม",
];

export default {
  components: {
    welcomecard,
  },
  data() {
    return {
      token: null,
      is_authorization: null,
      is_loading: "Y",
      is_exporting: "N",
      companyName: process.env.VUE_APP_COMPANY_NAME || "RUNNING DIGITAL SOLUTION CO., LTD.",
      companyTaxNo: process.env.VUE_APP_COMPANY_TAXNO || "-",
      companyAddress: process.env.VUE_APP_COMPANY_ADDRESS || "-",
      contractOwner: process.env.VUE_APP_CONTRACT_OWNER || "",
      contractPosition: process.env.VUE_APP_CONTRACT_POSITION || "",
      receiptSignature,
      printDate: "",
      eventData: {
        event_key: this.$route.params.event_key,
        title: "",
        event_date: "",
        location: "",
        organizer_info: "",
        create_date: "",
        is_system_fee: "N",
        system_fee_amt: 0,
        is_free_payment_fee: "N",
      },
      contract: {
        sign_date: "",
        organizer_name: "",
        organizer_signer_name: "",
        organizer_address: "",
        appendix_text: "",
      },
    };
  },
  computed: {
    providerSignerName() {
      return this.contractOwner.trim() || "…………………………………";
    },
    providerSignerPosition() {
      return this.contractPosition.trim() || "……………………………………………";
    },
    draftKey() {
      return "rr_contract_draft_" + this.eventData.event_key;
    },
    signDay() {
      return this.contract.sign_date ? Number(this.contract.sign_date.substring(8, 10)) : "………";
    },
    signMonthText() {
      if (!this.contract.sign_date) return "…………";
      const monthIndex = Number(this.contract.sign_date.substring(5, 7)) - 1;
      return THAI_MONTHS[monthIndex] || "…………";
    },
    signYearBe() {
      if (!this.contract.sign_date) return "………………";
      return Number(this.contract.sign_date.substring(0, 4)) + 543;
    },
    eventDateThai() {
      if (!this.eventData.event_date) return "-";
      const parts = this.eventData.event_date.substring(0, 10).split("-");
      if (parts.length !== 3) return this.eventData.event_date;
      const [y, m, d] = parts;
      return `${Number(d)} ${THAI_MONTHS[Number(m) - 1]} ${Number(y) + 543}`;
    },
    feePpText() {
      return "ร้อยละ 3 ของยอดชำระ";
    },
    feeCcText() {
      return "ร้อยละ 5 ของยอดชำระ";
    },
  },
  async mounted() {
    this.token = localStorage.getItem("_rr_token");
    if (this.token === null) {
      this.$router.push("/auth/login");
      return;
    }
    await this.authorization();
    if (this.is_authorization === "Y") {
      await this.load_event_detail();
      this.loadDraft();
    }
    this.printDate = this.buildPrintDate();
    window.addEventListener("beforeprint", this.refreshPrintDate);
  },
  beforeUnmount() {
    window.removeEventListener("beforeprint", this.refreshPrintDate);
  },
  methods: {
    async authorization() {
      const headers = { Authorization: "Bearer " + this.token };
      const data = { event_key: this.$route.params.event_key };
      const res = await axios.post("v1/organizer/authorization", data, { headers });
      if (res.data.status === "success") {
        this.is_authorization = res.data.message.is_authorization;
      } else {
        alert("พบข้อผิดพลาด[กรุณาแจ้งผู้ดูแลระบบ]: " + res.data.message);
      }
    },
    async load_event_detail() {
      this.is_loading = "Y";
      const headers = { Authorization: "Bearer " + this.token };
      const res = await axios.get("v1/organizer/event-edit/" + this.$route.params.event_key, { headers });
      if (res.data.status === "success" && res.data.body) {
        const ev = res.data.body;
        this.eventData.title = ev.title || "";
        this.eventData.event_date = ev.event_date || "";
        this.eventData.location = ev.location || "";
        this.eventData.organizer_info = ev.organizer_info || "";
        this.eventData.create_date = ev.create_date || "";
        this.eventData.is_system_fee = ev.is_system_fee || "N";
        this.eventData.system_fee_amt = ev.system_fee_amt || 0;
        this.eventData.is_free_payment_fee = ev.is_free_payment_fee || "N";

        if (!this.contract.organizer_name) {
          this.contract.organizer_name = "ผู้จัดกิจกรรม " + this.eventData.title;
        }
        if (!this.contract.sign_date) {
          this.contract.sign_date = this.eventData.create_date
            ? this.eventData.create_date.substring(0, 10)
            : new Date().toISOString().substring(0, 10);
        }
      } else {
        alert("ไม่พบข้อมูลกิจกรรม[กรุณาแจ้งผู้ดูแลระบบ]: " + (res.data.message || ""));
      }
      this.is_loading = "N";
    },
    saveDraft() {
      localStorage.setItem(this.draftKey, JSON.stringify(this.contract));
      alert("บันทึกร่างสัญญาเรียบร้อย");
    },
    loadDraft() {
      const raw = localStorage.getItem(this.draftKey);
      if (raw) {
        try {
          Object.assign(this.contract, JSON.parse(raw));
        } catch (e) {
          // ignore corrupted draft
        }
      }
    },
    buildTimestamp() {
      const pad = (n) => String(n).padStart(2, "0");
      const d = new Date();
      return (
        d.getFullYear() +
        pad(d.getMonth() + 1) +
        pad(d.getDate()) +
        pad(d.getHours()) +
        pad(d.getMinutes()) +
        pad(d.getSeconds())
      );
    },
    buildPrintDate() {
      const pad = (n) => String(n).padStart(2, "0");
      const d = new Date();
      return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getSeconds())}`;
    },
    refreshPrintDate() {
      this.printDate = this.buildPrintDate();
    },
    async downloadContractPdf() {
      const el = document.getElementById("contract-pdf");
      if (!el) return;
      this.is_exporting = "Y";
      this.refreshPrintDate();
      await this.$nextTick();
      try {
        const canvas = await html2canvas(el, { backgroundColor: "#ffffff", scale: 1.85 });
        const pdf = new jsPDF({ orientation: "p", unit: "mm", format: "a4", compress: true });
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
        const imageHeight = (canvas.height * pageWidth) / canvas.width;
        const image = canvas.toDataURL("image/jpeg", 0.85);

        pdf.addImage(image, "JPEG", 0, 0, pageWidth, imageHeight, undefined, "FAST");
        if (imageHeight > pageHeight) {
          let heightLeft = imageHeight - pageHeight;
          let position = -pageHeight;
          while (heightLeft > 0) {
            pdf.addPage();
            pdf.addImage(image, "JPEG", 0, position, pageWidth, imageHeight, undefined, "FAST");
            heightLeft -= pageHeight;
            position -= pageHeight;
          }
        }
        pdf.save(`contract-rrc-${this.eventData.event_key}-${this.buildTimestamp()}.pdf`);
      } finally {
        this.is_exporting = "N";
      }
    },
  },
};
</script>

<style scoped>
.contract-page-wrapper {
  display: flex;
  justify-content: center;
  background: #e9ecef;
  padding: 24px 0;
}
.contract-page {
  background: #ffffff;
  width: 210mm;
  min-height: 297mm;
  padding: 20mm 18mm;
  box-shadow: 0 0 6px rgba(0, 0, 0, 0.15);
  font-size: 14px;
  line-height: 1.7;
  color: #212529;
  position: relative;
}
.contract-header-topright {
  position: absolute;
  top: 10mm;
  right: 18mm;
  text-align: right;
  font-size: 10px;
  line-height: 1.4;
  color: #495057;
  max-width: 60mm;
}
.contract-header-topleft {
  position: absolute;
  top: 10mm;
  left: 18mm;
  font-size: 10px;
  color: #495057;
}
.contract-title {
  text-align: center;
  margin: 16px 0 20px;
}
.contract-page p {
  margin: 0 0 10px;
  text-align: justify;
}
.contract-page ul {
  margin: 0 0 10px 20px;
}
.signature-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  margin-top: 30px;
}
.signature-box {
  text-align: center;
}
.signature-line {
  position: relative;
  height: 10px;
}
.signature-image {
  position: absolute;
  bottom: -20px;
  left: 50%;
  transform: translateX(-50%);
  max-height: 45px;
}
.contract-print-date {
  text-align: right;
  font-size: 10px;
  color: #495057;
  margin-top: 10px;
}
@media print {
  .no-print {
    display: none !important;
  }
  .contract-page-wrapper {
    background: #ffffff;
    padding: 0;
  }
  .contract-page {
    box-shadow: none;
  }
}
</style>
